import { getTDTLayer } from '../Layer/defaultLayer/getTiandituLayer'
import { getTMSLayer } from '../Layer/getTMSLayer'
/**
 * @description 初始化默认图层
 * @param {Object} params 初始化参数
 * @example
 * const defaultTDT = {
 *    mapType: 'tdt',
 *    params: {
 *      key: '82cf878ce0a7719801f26ca2dcee8b73',
 *      layer: 'img',
 *      projection: 'w'
 *    }
 *  }
 *  const defaultBlue = {
 *    mapType: 'color',
 *  }
 *  const defaultInner = {
 *    mapType: 'inner',
 *  }
 */
function getDefaultImageLayer (params) {
  // const defaulteImageLayer = {
  //   type: 'tdt',
  //   name: "img_c",
  //   key: ''
  // }
  const imageLayerConfig = params.imageLayer || null

  let defaultImageLayer = getColorTypeBaseLayer()
  if (!imageLayerConfig) {
    return defaultImageLayer
  }
  const _mapType = imageLayerConfig.mapType || ''

  switch (_mapType) {
    case 'tdt': {
      defaultImageLayer = getTDTLayer(imageLayerConfig)
      break
    }
    case 'singleImage': {
      const singleParam3D = {
        url: imageLayerConfig.url,
        rectangle: Cesium.Rectangle.fromDegrees(-180, -90, 180, 90)
      }
      defaultImageLayer = new Cesium.SingleTileImageryProvider(singleParam3D)
      break
    }
    case 'innertdt': {
      defaultImageLayer = new Cesium.UrlTemplateImageryProvider({
        url: imageLayerConfig.url,
        subdomains: ['0', '1', '2', '3', '4', '5', '6', '7'],
        tilingScheme: new Cesium.WebMercatorTilingScheme(),
        maximumLevel: 5
      })
      // (imageLayerConfig)
      break
    }
    case 'inner': {
      defaultImageLayer = getInnerBackLayer()
      break
    }
    case 'color': {
      defaultImageLayer = getColorTypeBaseLayer()
      break
    }
    default: {
      defaultImageLayer = getInnerBackLayer()
      break
    }
  }
  return defaultImageLayer
}

// 内置影像图
function getInnerBackLayer () {
  const defaultImageLayer = new Cesium.TileMapServiceImageryProvider({
    url: Cesium.buildModuleUrl('Assets/Textures/NaturalEarthII')
  })
  return defaultImageLayer
}

// 获取颜色类型 底图
function getColorTypeBaseLayer () {
  // TODO 修改为 颜色从参数传递
  const defaultColor = Cesium.Color.BLUE
  const defaultImageLayer = new Cesium.GridImageryProvider({
    color: defaultColor,
    glowColor: defaultColor,
    backgroundColor: defaultColor,
    cells: 4
  })
  return defaultImageLayer
}

export default getDefaultImageLayer
